"use client"
import Image from "next/image";
import { useRef } from "react";

export default function Home() {
  const sodem = useRef(0)
  function congthem1() {
    sodem.current = sodem.current + 1;
    console.table(sodem);
  }
  return (
    <>
      <h3>Trạng thái hiện tại {sodem.current}</h3>
      <button className="btn btn-dark" onClick={congthem1}>Cộng thêm 1</button>
    </>
  );
}
